// extracted by mini-css-extract-plugin
export default {"container":"WelcomeMessage_container__Kwc3C","title":"WelcomeMessage_title__IHFpb","subtitle":"WelcomeMessage_subtitle__83s1X"};